import {
  ONLINE,
  OFFLINE,
  STATUS_MESSAGE,
  OPEN_PREFERENCES,
  OPEN_DEVICE_SYNC,
  SET_MIDI_THRU,
  REFRESH_THRU_PORTS
} from './actionTypes'

export const networkStatus = () => (navigator.onLine ? {type: ONLINE} : {type: OFFLINE})
export const setStatusMessage = (status) => ({type: STATUS_MESSAGE, status: status})
export const openPreferences = (status) => ({type: OPEN_PREFERENCES, status: status})
export const openDeviceSync = (status) => ({type: OPEN_DEVICE_SYNC, status: status})

export const setMIDIThruPort = (name) => {
  window.kboardthru = null
  return { type: SET_MIDI_THRU, portname: name }
}

export const refreshThruPorts = (name) => {
  window.kboardthru = null

  return (dispatch) => {
    setTimeout(() => {
      dispatch({ type: REFRESH_THRU_PORTS })
      dispatch({ type: SET_MIDI_THRU, portname: '' })
      setTimeout(() => dispatch({ type: SET_MIDI_THRU, portname: 'none' }), 250)
    }, 750)
  }
}